import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=c07680ba&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=c07680ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07680ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c07680ba')) {
      api.createRecord('c07680ba', component.options)
    } else {
      api.reload('c07680ba', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=c07680ba&scoped=true&", function () {
      api.rerender('c07680ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/nav/attribute.vue"
export default component.exports